var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m30.22988,59c-16.0221,0 -29,-12.9779 -29,-29c0,-16.0221 12.9779,-29 29,-29c16.0221,0 29,12.9779 29,29c0,16.0221 -12.9779,29 -29,29z",
    opacity: "undefined",
    strokeWidth: 2,
    stroke: "#faca15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111111",
    id: "svg_2",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m36.66666,20l-13.56321,0c-3.74534,0 -6.7816,2.2386 -6.7816,5l0,10c0,2.7614 3.03626,5 6.7816,5l13.56321,0c3.74534,0 6.7816,-2.2386 6.7816,-5l0,-10c0,-2.7614 -3.03626,-5 -6.7816,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m18.04601,21.60922l12.18387,6.43676",
    opacity: "undefined",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#111111",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m30.22988,28.04598l10.57468,-6.20687",
    opacity: "undefined",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#111111",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fea425181640eaedaa8ed92ce5012b1b.svg";
export { ForwardRef as ReactComponent };